import { ImageAProps } from "@src/ruix/types";

const ImageA = (props: ImageAProps) => {
	const { imgSrc, alt } = props;
	const imgSrcLast = imgSrc.split("/").pop();
	const altText = alt || imgSrcLast;

	const radius = props.radius || 10;

	const width = props.width || "100%";
	const height = props.height || "auto";

	return (
		<img
			style={{
				borderRadius: radius,
				width: width,
				height: height,
				objectFit: "cover",
			}}
			src={imgSrc}
			alt={altText}
		/>
	);
};

export default ImageA;
